/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_Suggestion_DismissInputs */

const en_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep current language`)
};

const ar_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإبقاء على اللغة الحالية`)
};

const bn_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বর্তমান ভাষা রাখুন`)
};

const de_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Sprache behalten`)
};

const es_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener el idioma actual`)
};

const fr_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garder la langue actuelle`)
};

const pt_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter o idioma atual`)
};

const zh_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留当前语言`)
};

const tr_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut dili koru`)
};

const ru_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставить текущий язык`)
};

const pl_lang_suggestion_dismiss = /** @type {(inputs: Lang_Suggestion_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozostań przy obecnym języku`)
};

/**
* | output |
* | --- |
* | "Keep current language" |
*
* @param {Lang_Suggestion_DismissInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const lang_suggestion_dismiss = /** @type {((inputs?: Lang_Suggestion_DismissInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Suggestion_DismissInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_lang_suggestion_dismiss(inputs)
	if (locale === "bn") return bn_lang_suggestion_dismiss(inputs)
	if (locale === "de") return de_lang_suggestion_dismiss(inputs)
	if (locale === "es") return es_lang_suggestion_dismiss(inputs)
	if (locale === "fr") return fr_lang_suggestion_dismiss(inputs)
	if (locale === "pt") return pt_lang_suggestion_dismiss(inputs)
	if (locale === "zh") return zh_lang_suggestion_dismiss(inputs)
	if (locale === "tr") return tr_lang_suggestion_dismiss(inputs)
	if (locale === "ru") return ru_lang_suggestion_dismiss(inputs)
	if (locale === "pl") return pl_lang_suggestion_dismiss(inputs)
	return en_lang_suggestion_dismiss(inputs)
});